export const figure30 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#ed7d31', '#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: [
"Mundo",
"África septentrional y Asia occidental",
"África subsahariana",
"Oceanía (excluidas Australia y Nueva Zelandia)",
"América del Norte y Europa",
"América Latina y el Caribe",
"Asia oriental y Asia sudoriental",
"Asia central y Asia meridional",
"Australia y Nueva Zelandia",
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        max: 90,
        min: 0,
        tickInterval: 10,
        gridLineWidth: 2,
        title: {
          text: null,
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2018',
        data: [19.01, 12.31, 12.89, 79.78, 50.46, 11.89, 18.86, 2.95, 61.97],
      },
      {
        name: '2015',
        data: [17.28, 11.48, 12.48, 77.57, 46.98, 12.2, 15.77, 2.47, 57.47]
      }
    ]
}